import { getToken } from '@/utils/token'
import { getUser } from '@/utils/user'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { AuthModule } from './types'

const auth: AuthModule = {
  state: () => ({
    accessToken: getToken(),
    user: getUser(),
    isShowAuthIframe: false
  }),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default auth
